/**
 * Runtime configuration.
 *
 * When the web bundle is served by Laravel (app.* subdomain), the server
 * injects `window.PINEAPPLE_CONFIG` into index.html so the API URL and
 * friends can be changed on the fly without rebuilding the bundle.
 *
 * Local Vite/CLI builds fall back to compile-time VUE_APP_* values.
 */

export interface PineappleRuntimeConfig {
    apiUrl?: string;
    webUrl?: string;
    socketUrl?: string;
    pusherAuthEndpoint?: string | null;
    revenueCatWebKey?: string | null;
}

declare global {
    interface Window {
        PINEAPPLE_CONFIG?: PineappleRuntimeConfig;
    }
}

const runtime: PineappleRuntimeConfig =
    (typeof window !== 'undefined' && window.PINEAPPLE_CONFIG) || {};

/** Same-origin PWA proxy by default (`/pwa-api`). */
export const API_URL =
    runtime.apiUrl || (process.env.VUE_APP_API as string) || '/pwa-api';

export const WEB_URL = runtime.webUrl || (process.env.VUE_APP_WEB_URL as string);

/** Socket.IO origin (API host, not under /v1/api/app). */
export const SOCKET_URL =
    runtime.socketUrl ||
    (process.env.VUE_APP_SOCKET_URL as string) ||
    (process.env.VUE_APP_API_ORIGIN as string) ||
    '';

/** @deprecated Pusher is not used by the app API contract. */
export const PUSHER_AUTH_ENDPOINT =
    runtime.pusherAuthEndpoint || (process.env.VUE_APP_PUSHER_APP_AUTH_ENDPOINT as string) || '';

/** @deprecated RevenueCat is not used by the PWA; Verotel is. */
export const REVENUECAT_WEB_KEY =
    runtime.revenueCatWebKey || (process.env.VUE_APP_REVENUECAT_WEB_KEY as string) || '';
